import { render, staticRenderFns } from "./Plaque.vue?vue&type=template&id=bd3260ea&scoped=true"
import script from "./Plaque.vue?vue&type=script&lang=js"
export * from "./Plaque.vue?vue&type=script&lang=js"
import style0 from "./Plaque.vue?vue&type=style&index=0&id=bd3260ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3260ea",
  null
  
)

export default component.exports